<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"> </p>
<p class="center"><a id="page_i"></a><strong>Acclaim for <em>The Heart of Redness</em></strong></p>
<p class="noindentt">“A major step in the new South African novel—now a polyphony of voices, suddenly freed yet still shadowed by deep and immense riddles.”</p>
<p class="attribute">—<em>The Village Voice</em></p>
<p class="noindentt">“Zakes Mda writes of his troubled homeland with as much affection as outrage, as much love as lamentation . . . . This emotionally rich novel dares to seek redemption amid desolation. In these devastated lives, Mda finds grace, tenderness, even the kind of world-weary humor that is born of hardship.”</p>
<p class="attribute">—<em>The Boston Globe</em></p>
<p class="noindentt">“A novel of tremendous scope and deep human feeling, of passion and reconciliation. . . A seamless weave of history, myth, and realist fiction. It is, arguably, the first great novel of the new South Africa—a triumph of imaginative and historical writing.”</p>
<p class="attribute">—<em>The Seattle Skanner</em></p>
<p class="noindentt">“In an unaffected, generous style that blends social and magical realism, oral tradition and written history, Mda spins stories that both read like myth and chronicle ordinary South African life.”</p>
<p class="attribute">—<em>The Philadelphia Inquirer</em></p>
<p class="noindentt">“Jumping handily between past and present, Mda deftly renders the tensions between maintaining an indigenous culture and altering it in the name of progress.”</p>
<p class="attribute">—<em>Entertainment Weekly</em></p>
<p class="noindentt">“Mda tells his country’s stories through beautifully realized characters whose search for love and connection take you up close to the black experience, past and present.”</p>
<p class="attribute">—<em>Booklist</em></p>
<p class="noindentt">“A prolific and prominent new voice of South African literature, Mda transforms historical events and invents new ones that express his continued concern, as in these two novels, that the liberators do not become the oppressors . . . A brilliantly profuse novel. . . provocatively offbeat and tragically weird.”</p>
<p class="attribute">—Los <em>Angeles Times Book Review</em></p>
<p class="noindentt"><a id="page_ii"></a>“A nuanced story about belief, memory, and the complex legacies of colonialism and its contemporary heir, global capitalism. [Mda] paints a vivid picture of a new South Africa of uncertain future . . . where the past is deeply contested terrain and social equality remains a faraway dream.”</p>
<p class="attribute">—<em>Mother Jones</em></p>
<p class="noindentt">“Mda’s fascinating narrative skill reveals the past as a powerful presence in the present: of his characters, and of all of us, as we live.”</p>
<p class="attribute">—Nadine Gordimer</p>
<p class="noindentt">“A work of extraordinary richness, suffused with genuine mythic power: comparable to the recently discovered fiction of Moses Iszegawa and Emmanuel Dongala—and not unworthy of comparison with the masterpieces of Chinua Achebe.”</p>
<p class="attribute">—<em>Kirkus Reviews</em> (starred review)</p>
<p class="noindentt">“Rich in the sensuality and exoticism of African life.”</p>
<p class="attribute">—<em>The Commercial Appeal</em> (Memphis)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?140a5a9f